var map = {
	"./alliantie_kinderarmoede.png": 3293,
	"./armoede_fonds.png": 3456,
	"./compete.png": 6176,
	"./kinder_hulp.png": 9649,
	"./lunchmaatjes.png": 7475,
	"./nationaal_jeugd_ontbijt.png": 4391,
	"./nationaal_school_ontbijt.png": 1996,
	"./ngelm.png": 7223,
	"./s.png": 272,
	"./samen.png": 6645,
	"./save_the_children.png": 5647,
	"./sdg_1.png": 9628,
	"./tommy_tomato.png": 4727,
	"./voedseleducatie_010.png": 9975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4995;